import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "p-col-5",
  style: {"border":"none"}
}
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = { class: "p-d-flex p-jc-end" }
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "p-col-5" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = { class: "p-d-flex p-jc-end" }
const _hoisted_8 = ["for"]
const _hoisted_9 = {
  key: 0,
  class: "p-buttonset p-col-2"
}
const _hoisted_10 = { class: "p-col-5" }
const _hoisted_11 = { class: "p-float-label" }
const _hoisted_12 = { class: "p-d-flex p-jc-end" }
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "p-col-5" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = { class: "p-d-flex p-jc-end" }
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "p-buttonset p-col-2" }

import { TimeDataInput } from "@/graphql/types";
import moment from "moment";
import { useToast } from "primevue/usetoast";
import { ref } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'PointingForm',
  props: {
    times: { default: () => [] },
    previousTimes: {},
    date: {},
    min: {}
  },
  emits: ["update:times", "update:previousTimes", "onSubmit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;
const props = __props;

const submitButtonRef = ref<HTMLButtonElement>(null);
const toast = useToast();
const { t } = useI18n();
const minDate = props.min
  ? moment(props.min).startOf("day").toDate()
  : moment(props.date).startOf("day").toDate();
const maxDate = moment(props.date).add(1, "days").endOf("day").toDate();
const maxPrevDate = moment(props.date).endOf("day").toDate();
const isPast = moment(props.date).isSameOrBefore(moment(), "day");

const updateModelValue = (index: number, field: string, date: Date) => {
  const times = [...props.times];
  times[index][field] = date;
  emit("update:times", times);
};

const updatePrevious = (index: number, field: string, date: Date) => {
  const previous = [...props.previousTimes];
  previous[index][field] = date;
  emit("update:previousTimes", previous);
};

const getLastEntry = () => {
  const previousTimes = [...(props?.previousTimes || [])].reverse();

  const lastDate = previousTimes[previousTimes.length - 1]?.exit;
  return lastDate ? new Date(lastDate) : minDate;
};

const handleAdd = () => {
  const times = [...props.times];
  times.push({
    entry: times[times.length - 1]?.exit || getLastEntry(),
    exit: null,
  });
  const lastIndex = times.length - 2;
  const lastExit = times[lastIndex]?.exit;
  if (lastExit !== null && lastExit !== "null") {
    emit("update:times", times);
  } else {
    toast.add({
      severity: "error",
      summary: "Erreur",
      detail: "Veuillez renseigner la dernière date de sortie",
      life: 3000,
    });
  }
};

const handleDelete = (index: number) => {
  const times = [...props.times];
  times.splice(index, 1);
  emit("update:times", times);
};

const submit = () => {
  submitButtonRef.value?.click();
};

const onSubmit = (event: Event) => {
  event.preventDefault();
  const timesData = props.times.filter((t) => !t.entry);
  if (timesData.length) {
    toast.add({
      severity: "error",
      summary: t("hr_pointing"),
      detail: t("hr_pointing_entry_required"),
      life: parseInt(process.env.VUE_APP_TOAST_LIFE),
    });
    return;
  }
  emit("onSubmit", event);
};

__expose({ submit });

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: onSubmit,
    autocomplete: "off"
  }, [
    (_ctx.previousTimes?.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previousTimes, (date, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "p-grid p-mt-4",
              key: index
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_component_Calendar, {
                    modelValue: date.entry,
                    disabled: true,
                    showIcon: true,
                    showTime: true,
                    showSeconds: true,
                    id: `prev_entry_hour_${index}`,
                    ref_for: true,
                    ref: `prev_entry_hour_${index}`
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_Button, {
                          class: "p-button-text p-button-sm",
                          label: _ctx.$t('close'),
                          onClick: ($event: any) => (
                      _ctx.$refs[`prev_entry_hour_${index}`].overlayVisible = false
                    )
                        }, null, 8, ["label", "onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "id"]),
                  _createElementVNode("label", {
                    for: `prev_entry_hour_${index}`
                  }, "Heure d'entrée", 8, _hoisted_4)
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_Calendar, {
                    modelValue: date.exit,
                    "onUpdate:modelValue": ($event: any) => (updatePrevious(index, 'exit', $event)),
                    showIcon: true,
                    showTime: true,
                    showSeconds: true,
                    id: `previous_exit_hour_${index}`,
                    minDate: date.entry,
                    maxDate: _unref(maxPrevDate),
                    ref_for: true,
                    ref: `previous_exit_hour_${index}`
                  }, {
                    footer: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_Button, {
                          class: "p-button-text p-button-sm",
                          label: _ctx.$t('close'),
                          onClick: ($event: any) => (
                      _ctx.$refs[
                        `previous_exit_hour_${index}`
                      ].overlayVisible = false
                    )
                        }, null, 8, ["label", "onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "id", "minDate", "maxDate"]),
                  _createElementVNode("label", {
                    for: `prevoius_exit_hour_${index}`
                  }, "Heure de sortie", 8, _hoisted_8)
                ])
              ]),
              (!_ctx.times.length && _unref(isPast))
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createVNode(_component_Button, {
                      onClick: handleAdd,
                      icon: "pi pi-plus",
                      class: "p-button-success p-button-text"
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.times.length)
            ? (_openBlock(), _createBlock(_component_Divider, { key: 0 }))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.times, (date, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "p-grid p-mt-4",
        key: index
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_Calendar, {
              modelValue: date.entry,
              "onUpdate:modelValue": ($event: any) => (updateModelValue(index, 'entry', $event)),
              showIcon: true,
              showTime: true,
              showSeconds: true,
              id: `entry_hour_${index}`,
              maxDate: _unref(maxDate),
              minDate: _unref(minDate),
              ref_for: true,
              ref: `entry_hour_${index}`
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Button, {
                    class: "p-button-text p-button-sm",
                    label: _ctx.$t('close'),
                    onClick: ($event: any) => (_ctx.$refs[`entry_hour_${index}`].overlayVisible = false)
                  }, null, 8, ["label", "onClick"])
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "id", "maxDate", "minDate"]),
            _createElementVNode("label", {
              for: `entry_hour_${index}`
            }, "Heure d'entrée ", 8, _hoisted_13)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, [
            _createVNode(_component_Calendar, {
              modelValue: date.exit,
              "onUpdate:modelValue": ($event: any) => (updateModelValue(index, 'exit', $event)),
              showIcon: true,
              showTime: true,
              showSeconds: true,
              id: `exit_hour-${index}`,
              minDate: date.entry,
              maxDate: _unref(maxDate),
              ref_for: true,
              ref: `exit_hour-${index}`
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Button, {
                    class: "p-button-text p-button-sm",
                    label: _ctx.$t('close'),
                    onClick: ($event: any) => (_ctx.$refs[`exit_hour-${index}`].overlayVisible = false)
                  }, null, 8, ["label", "onClick"])
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "id", "minDate", "maxDate"]),
            _createElementVNode("label", {
              for: `exit_hour-${index}`
            }, "Heure de sortie", 8, _hoisted_17)
          ])
        ]),
        _createElementVNode("span", _hoisted_18, [
          (index == _ctx.times.length - 1)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: handleAdd,
                disabled: !_unref(isPast),
                icon: "pi pi-plus",
                class: "p-button-success p-button-text"
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.previousTimes?.length && _ctx.times.length > 1)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                onClick: ($event: any) => (handleDelete(index)),
                icon: "pi pi-trash",
                class: "p-button-danger p-button-text"
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _withDirectives(_createElementVNode("button", {
      ref_key: "submitButtonRef",
      ref: submitButtonRef,
      type: "submit"
    }, null, 512), [
      [_vShow, false]
    ])
  ], 32))
}
}

})